export default __webpack_public_path__ + "static/media/home_mane_event.ea2cd945.mp3";